export default "__VITE_ASSET__CBFGLaX0__"